export const transparencia_item = [
    {
        "transparencia_item_nombre" : "Art. 69 Ley de Transparencia (48 Rubros)",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Art. 70 Ley de Transparencia",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Mubles y Servicios ",
        "transparencia_item_url" : "Rubros"
    }
    
        
]